<template>
  <div>
    <div
      v-if="item.checked_user && item.status == 'CHECADO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0"
    >
      <h6
        :class="[
          'text-eleven upper-text mb-0 p-1 text-center user-name-checked',
          handleColorUser(item.prescription_medicine_time.time),
        ]"
        v-for="doc in professionalClassCouncilValue({
          id: item.checked_user.professional_class_council_id,
          name: item.checked_user.name,
          cpf: item.checked_user.cpf,
          value: item.checked_user.professional_class_council_value,
          profile: item.checked_user.profile_name,
        })"
        :key="doc.position"
      >
        {{ doc.text }}
      </h6>
    </div>

    <h6
      v-if="item.status == 'SUSPENSO'"
      class="text-prescription-medicine-suspended text-center p-1"
    >
      SUSPENSO
    </h6>

    <div
      v-if="item.status != 'SUSPENSO'"
      class="
        d-flex
        justify-content-center
        align-items-center
        col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
        p-1
      "
    >
      <div class="row">
        <div
          class="
            col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
            pt-0
            pb-0
            pl-1
            pr-1
            text-center
          "
        >
          <img
            class="checked-icon"
            v-if="item.status == 'CHECADO' && item.checked"
            :src="require('../../../../../assets/check/checked.svg')"
          />
          <img
            class="checked-icon"
            v-if="item.status == 'CHECADO' && !item.checked"
            :src="require('../../../../../assets/check/hefty.svg')"
          />
        </div>
        <div
          :class="[
            'pt-0 pb-0 pl-1 pr-1',
            item.status == 'CHECADO' &&
              'col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6',
            item.status != 'CHECADO' &&
              'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12',
          ]"
        >
          <div v-if="item.prescription_medicine_time.drops">
            <h6 class="legends text-center worksansr mb-0">
              {{ item.prescription_medicine_time.drops }}
            </h6>
            <h6 class="legends text-center worksansr mb-0">GOTA(S)</h6>
          </div>
          <div v-if="item.prescription_medicine_time.ui">
            <h6 class="legends text-center worksansr mb-0">
              {{ item.prescription_medicine_time.ui }}
            </h6>
            <h6 class="legends text-center worksansr mb-0">UI</h6>
          </div>
          <div
            v-if="
              !item.prescription_medicine_time.drops &&
              !item.prescription_medicine_time.ui
            "
          >
            <h6 class="legends text-center worksansr mb-0">
              {{ item.prescription_medicine_time.quantity }}
            </h6>
            <h6 class="legends text-center worksansr mb-0">
              {{
                item.prescription_medicine_time.unit_of_measurement_abbreviation
              }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  categoryCoren,
  onlyCategoryCoren,
  formatTimeOnlyNumbers,
} from "../../../../../lib/format";

export default {
  name: "Monthly",
  props: {
    item: Object,
  },
  methods: {
    categoryCoren,
    onlyCategoryCoren,
    formatTimeOnlyNumbers,
    handleColorUser(time) {
      if (
        parseInt(formatTimeOnlyNumbers(time)) >= parseInt(70000) &&
        parseInt(formatTimeOnlyNumbers(time)) < parseInt(190000)
      ) {
        return "c-primary";
      }

      return "c-danger";
    },
    professionalClassCouncilValue({
      id = null,
      name = "",
      cpf = "",
      value = "",
      // profile = "",
    }) {
      const TYPE_COREN = 1;
      const TYPE_CRM = 2;

      name = String(name).split(" ");
      name = `${name[0]} ${name[1] ? String(name[1]).substr(0, 3) : ""}.`;

      if (id == TYPE_COREN) {
        // let category = categoryCoren(onlyCategoryCoren(value));
        value = String(value).substr(9);
        value = String(value).substr(0, value.length - 3);

        return [
          { position: 1, text: `${name} ${value}` },
          // { position: 2, text: value },
          // { position: 3, text: category },
        ];
      }

      if (id == TYPE_CRM) {
        return [
          { position: 1, text: `${name} ${value}` },
          // { position: 2, text: value },
        ];
      }

      return [
        { position: 1, text: `${name} ${cpf}` },
        // { position: 2, text: cpf },
      ];
    },
  },
};
</script>
